import { render, staticRenderFns } from "./AddBranch.vue?vue&type=template&id=59279a19"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports